<template>
  <section class="ah-product-section" v-show="isVisible">
    <header class="ah-product-section-header">
      <h2 class="ah-product-section-heading">
        {{ heading }}
      </h2>
    </header>
    <div class="ah-product-section-items row">
      <product-card
        v-if="product.isMaterial === false || categoryId === 3000"
        class="ah-product-section-item col-xl-3 col-lg-4 col-md-4 col-sm-6"
        v-for="(product, i) in products"
        :key="`product-${i}`"
        :image="product.image"
        :species="product.species"
        :category="heading"
        :heading="product.name"
        :excerpt="product.description"
        :links="product.links"
        :isMaterial="product.isMaterial"
      />
    </div>
    <footer class="ah-product-section-footer">
      <button
        v-if="showExpandButton"
        class="ah-product-section-expand-button"
        @click="expand"
      >
        {{ label }}
      </button>
    </footer>
  </section>
</template>

<script>
  import ProductCard from './ProductCard/ProductCard.vue'
  import { getters } from '../data/store'

  export default {
    name: 'product-section',
    props: {
      heading: String,
      categoryId: Number,
      button: Object,
      isExpandable: {
        type: Boolean,
        default: false,
      }
    },
    data: function() {
      return {
        count: 8,
        showExpandButton: false,
        label: window.vueData.components['search-results'].expandButtonLabel || 'Show more'
      }
    },
    computed: {
      products: function() {
        let products = getters.products(this.categoryId)
        if (products.length > this.count) {
          this.showExpandButton = true
        } else {
          this.showExpandButton = false
        }
        return products.splice(0, this.count)
      },
      isVisible: function() {
        return this.products.length > 0
      }
    },
    methods: {
      expand: function() {
        this.count += 8
      }
    },
    components: {
      ProductCard,
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../scss/_variablesAH.scss";

  .ah-product-section {
    margin: 32px 0;
  }
  .ah-product-section-header {
    margin-bottom: 32px;
  }
  .ah-product-section-heading {
    font-family: $font-main;
    font-size: 26px;
    color: $blue-a;
  }
  .ah-product-section-items {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: -15px;
  }
  .ah-product-section-item {
    /*margin: 15px;*/
  }
  .ah-product-section-footer {
    margin-top: 30px;
  }
  .ah-product-section-expand-button {
    width: 100%;
    height: 50px;
    background-color: $blue-a;
    color: $ah-orange;
    font-family: $font-main;
    font-size: 18px;
    font-weight: 600;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
</style>